<template>
  <div class="navigation">
    <main :style="`grid-template-columns: repeat(${data.length}, auto)`" ref="GetPopupContainer">
      <div v-for="(item,index) in data" :key="index">
        <a-dropdown :getPopupContainer="() => $refs.GetPopupContainer" placement="bottomCenter">
          <div :class="`title ${getActive(item) && 'active'}`" @click="submit(item)"><span>{{item.label}}</span><i v-if="item.children" class="iconfont icon-wjjf_icon_line_arrow_down" /></div>
          <AntMenu className="antd_menu_navigation" v-if="item.children" :data="item.children" :defaultSelectedKeys="[$route.path]" slot="overlay" placement="bottom" class="antd_menu" align="center" :submit="submit" />
        </a-dropdown>
      </div>
    </main>
    <a-modal :centered="true" title="提示" :visible="reveal" @cancel="() => setReveal()" :footer="null" width="70rem">
      <div class="antd_modal">
        <img :src="require('@/assets/images/public/call_example.png')" alt="" srcset="">
        <div class="antd-model-tips">温馨提示：该内容为本站VIP会员专享，升级VIP请联系客服。服务热线:027-87665517转6003。邮箱: userservice@sunther.com</div>
      </div>
    </a-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: [],
      standardSearch: {},
      reveal: false,
      standardSearchList: {}, // 标准检索
      platformAssistantList: {}, // 平台助手
    }
  },
  created() {
    this.setStandard();
    this.setPlatformAssistant();
    this.setData();
  },
  methods: {
    getActive({ label = null, key = null, value = null }) {
      let { path = null, query = null } = this.$route;
      if (value) {
        switch (label) {
          case "标准检索": return path === value;
          case "中外标准对标展示": return query.url === value;
          case "平台助手": return path === value;
        }
      } else {
        return path === key;
      }
    },
    setReveal(value = false) {
      this.reveal = value;
    },
    submit({ mode, key }) {
      let fn = () => key && this.$router.$push(key);
      if (mode) {
        if (key == "/standardList/item") {
          this.$FN.limitsTips({ list: mode, key: "some", tips: false }).then(res => res ? fn() : this.setReveal(!res));
        } else {
          this.$FN.limitsTips({ list: mode, key: "some" }).then(res => res && fn());
        }
      } else {
        fn();
      };
    },
    setStandard() {
      let standardSearchList = {};
      let list = [
        { label: "标准检索", key: "/standard?mode=standardSearch_system_search", mode: ["standardSearch_system_search"], rolesKey: "standardSearch" },
        { label: "中南电力设计院", key: "/standard?mode=standardSearch_zny_allStartStopBtn", mode: ["standardSearch_zny_allStartStopBtn"], rolesKey: "standardSearch_zny_allStartStopBtn" },
        { label: "国核电力规划设计研究院", key: "/standard?mode=standardSearch_state_nuclear_search_list_details", mode: ["standardSearch_state_nuclear_search_list_details"], rolesKey: "standardSearch_state_nuclear_search_list_details" },
        { label: "中能建广西电力设计研究院", key: "/standard?mode=standardSearch_intermediate_energy_search_list_details", mode: ["standardSearch_intermediate_energy_search_list_details"], rolesKey: "standardSearch_intermediate_energy_search_list_details" },
      ];

      let mode = ["standardSearch_system", "standardSearch_zny_allStartStopBtn", "standardSearch_state_nuclear_search_list_details", "standardSearch_intermediate_energy_search_list_details"];

      let returnedValue = this.$FN.filterLimitsVisible({ data: list });
      if (returnedValue.length === 1) {
        standardSearchList = { label: "标准检索", key: "/standard?mode=standardSearch_system_search", rolesKey: "standardSearch", value: "/standard", mode };
      } else {
        let obj = { label: "标准检索", rolesKey: "standardSearch", mode, key: "/standard?mode=standardSearch_system_search", value: "/standard", children: this.$FN.filterLimitsVisible({ data: list }) };
        standardSearchList = obj;
      };
      this.standardSearchList = standardSearchList;
      this.setData();
    },
    // 设置平台助手
    setPlatformAssistant() {
      // 1（2018、2019、2020） && 2（2021、2022、2023、2024） 属于标准有效版本
      // 3（2018、2019、2020） && 4（2021、2022、2023、2024） 属于国际工程清单
      // rolesKey非常重要，与权限有关，用来判断是否存在这个
      // mode用来判断用户有没有权限点进去，没有权限就提示
      this.platformAssistantList = {
        label: "平台助手", value: "/platformAssistant", mode: ["surveyDesign_teamworks_tandard_2018"], rolesKey: "surveyDesign",
        children: [
          {
            label: "协同工作",
            children: [
              { label: "2018标准有效版本清单", key: '/platformAssistant?type=1&key=2018', mode: ["surveyDesign_teamworks_tandard_2018"] },
              { label: "2019标准有效版本清单", key: '/platformAssistant?type=1&key=2019', mode: ["surveyDesign_teamworks_tandard_2019"] },
              { label: "2020标准有效版本清单", key: '/platformAssistant?type=1&key=2020', mode: ["surveyDesign_teamworks_tandard_2020"] },
              { label: "2021标准有效版本清单", key: '/platformAssistant?type=2&key=2021', mode: ["surveyDesign_teamworks_tandard_2021"] },
              { label: "2022标准有效版本清单", key: '/platformAssistant?type=2&key=2022', mode: ["surveyDesign_teamworks_tandard_2022"] },
              { label: "2023标准有效版本清单", key: '/platformAssistant?type=2&key=2023', mode: ["surveyDesign_teamworks_tandard_2023"] },
              { label: "2024标准有效版本清单", key: '/platformAssistant?type=2&key=2024', mode: ["surveyDesign_teamworks_tandard_2024"] },
              { label: "2018国际工程标准清单", key: '/platformAssistant?type=3&key=2018', mode: ["surveyDesign_teamworks_internation_2018"] },
              { label: "2019国际工程标准清单", key: '/platformAssistant?type=3&key=2019', mode: ["surveyDesign_teamworks_internation_2019"] },
              { label: "2020国际工程标准清单", key: '/platformAssistant?type=3&key=2020', mode: ["surveyDesign_teamworks_internation_2020"] },
              { label: "2021国际工程标准清单", key: '/platformAssistant?type=4&key=2021', mode: ["surveyDesign_teamworks_internation_2021"] },
              { label: "2022国际工程标准清单", key: '/platformAssistant?type=4&key=2022', mode: ["surveyDesign_teamworks_internation_2022"] },
              { label: "2023国际工程标准清单", key: '/platformAssistant?type=4&key=2023', mode: ["surveyDesign_teamworks_internation_2023"] },
              { label: "2024国际工程标准清单", key: '/platformAssistant?type=4&key=2024', mode: ["surveyDesign_teamworks_internation_2024"] }
            ]
          },
        ]
      }
    },
    setData() {
      let { standardSearchList = {}, platformAssistantList = {} } = this;
      let list = [
        { label: "首页", key: "/home" },
        standardSearchList,
        { label: "数字化标准比对", key: "/digitization", rolesKey: "digitization", mode: ["digitization_list"] },
        {
          label: "中外标准对标展示", key: `/benchmarking?type=0`, rolesKey: "benchmarking", mode: ["benchmarking_details"], value: `${this.$FN.iframeUrl}/npg/kres/output`,
          children: [
            { label: "勘察设计对标", key: "/benchmarking?type=0", mode: ["benchmarking_details"] }, // 后续替换成自己路由时解开
            { label: "安装施工对标", key: "/benchmarking?type=1", mode: ["benchmarking_reconnaissance_list"] }, // 后续替换成自己路由时解开
          ]
        },
        { label: "中国标准英文出版物", key: "/standardTranslation", rolesKey: "standardTranslation", mode: ["standardTranslation_list"] },
        { label: "国别技术法规", key: "/technicalRegulations", rolesKey: "technicalRegulations", mode: ["technicalRegulations_list"] },
        { label: "标准化语言服务", key: "/languageService", rolesKey: "languageService", mode: ["languageService_order"] },
        { label: "国际招标信息", key: "/call", rolesKey: "call", mode: ["call_list"] },
        { label: "国际信息导航", key: "/informationNavigation", rolesKey: "informationNavigation", mode: ["informationNavigation_list"] },
        { label: "国际电力工程标准清单", key: "/standardList/item", rolesKey: "standardList", mode: ["standardList_list_item"] },
        platformAssistantList,
        { label: "CEPPEA标准", key: `/ceppeaStandard`, rolesKey: "ceppea" }
      ];
      this.data = this.$FN.filterLimitsVisible({ data: list });
    }
  }
}
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>
<style lang="less">
body {
  .antd_menu_navigation {
    position: relative;
    top: -3px;
    .ant-dropdown-menu-item {
      text-align: center;
      .active {
        font-weight: bold;
        color: @vice-color;
      }
    }
    // 标准检索 - 中外标准对标展示
    .ant-menu {
      padding: 10px 0;
      .ant-menu-item {
        height: 35px;
        line-height: 35px;
        margin: 0 !important;
        // background: pink;
      }
      .ant-menu-item-active {
        font-weight: bold;
      }
      .ant-menu-item-selected {
        color: @vice-color;
        font-weight: bold;
      }
    }
  }
  .ant-modal-root {
    .antd_modal {
      img {
        width: 100%;
      }
      .antd-model-tips {
        .pub_font_size();
        margin-top: 10px;
      }
    }
  }

  // 平台助手-菜单-子菜单
  .ant-menu-submenu-popup {
    .ant-menu {
      padding: 5px 0;
      .antd_menu_item_default {
        height: 35px;
        line-height: 35px;
      }
      .ant-menu-item-active {
        font-weight: bold;
      }
      .ant-menu-item-selected {
        color: @vice-color;
        font-weight: bold;
      }
    }
  }
}
</style>